import { render, staticRenderFns } from "./sitestext.vue?vue&type=template&id=8c687590&"
import script from "./sitestext.vue?vue&type=script&lang=js&"
export * from "./sitestext.vue?vue&type=script&lang=js&"
import style0 from "./sitestext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports